export const colors = {
  GREAT: '#66cc99',
  GOOD: '#ffcc99',
  AVERAGE: '#ffcc99',
  POOR: '#ff6666',
  DEFAULT: '#A9AEB7',
}
export const base = {
  lang: {
    thousandsSep: ','
  },
  chart: {
    margin: [10, 10, 10, 10],
    spacing: [10, 10, 10, 10],
  },
  title: {
    text: null,
  },
  tooltip: {

  },
  plotOptions: {
    bar: {
      dataLabels: {
        enabled: true
      },
      zoneAxis: 'y',
      zones: null,
      cursor: 'pointer',
      events: {},
    }
  },
  legend: {
    enabled: false,
  },
  credits: {
    enabled: false
  },
  xAxis: {
    categories: null,
    title: {
      text: null
    }
  },
  yAxis: {
    min: 0,
    title: {
      text: 'score',
      align: 'high'
    },
    labels: {
      overflow: 'justify'
    }
  },
  series: null,
}

export default { base, colors }